import type { IconData } from '@stacksjs/iconify-core'

export const masterCard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.273 18.728A6.728 6.728 0 1 1 22 11.999V12a6.735 6.735 0 0 1-6.727 6.728\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M8.727 18.728A6.728 6.728 0 1 1 15.455 12a6.735 6.735 0 0 1-6.728 6.728\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default masterCard
